import { RatingComponent } from './rating.component';

export default angular
  .module('sfMobile.components.rating', [])
  .component('sfRating', RatingComponent).name;
